export const COMPANY_CONFIGURATIONS = 'COMPANY_CONFIGURATIONS';

const initialState = null; 

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case COMPANY_CONFIGURATIONS:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "companyConfigurations";

const storeMapping = {[storeName]: reducer};

export const companyConfigurationsSelector = (state) => state[storeName];

export default storeMapping;
